import { useEffect, useRef } from 'react';
import { useNavContext } from '../providers/NavProvider';

function Section({ name, alias, type = '', children }) {
  const { setActiveSection } = useNavContext();

  const ref = useRef(null);

  useEffect(() => {
    const currentRef = ref.current;
    const observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: "-40% 0px -50% 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(alias || name);
        }
      });
    }, observerOptions);

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [alias, name, setActiveSection]);

  return (
    <section ref={ref} className={`section ${name.toLowerCase()} ${type}`} id={alias ? alias : name}>
      {children}
    </section>
  );
}

export default Section;